const ocorrenciaRoutes = [
  // Boleto
  {
    path: '/ocorrencias',
    name: 'ocorrencia-list',
    component: () => import('@/views/ocorrencia/OcorrenciaDashboard.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Ocorrências', active: true },
      ],
    },
  },
  {
    path: '/ocorrencia/new',
    name: 'ocorrencia-view',
    component: () => import('@/views/ocorrencia/OcorrenciaEdit.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Ocorrências', url: '/ocorrencias' },
        { title: 'Nova', active: true },
      ],
    },
  },
  {
    path: '/ocorrencia/:id',
    name: 'ocorrencia-view',
    component: () => import('@/views/ocorrencia/OcorrenciaView.vue'),
    meta: {
      resource: 'Auth',
      action: 'read',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Ocorrências', url: '/ocorrencias' },
        { title: 'Visualizar', active: true },
      ],
    },
  },
]

export default ocorrenciaRoutes
